import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { AuthRecord } from 'pocketbase';

import { pb } from '@/lib/pocketbase';

type AuthContextValue = {
  user: AuthRecord | null;
  isAuthenticated: boolean;
};

const AuthContext = createContext<AuthContextValue>({ user: null, isAuthenticated: false });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthRecord | null>(pb.authStore.record);

  useEffect(() => {
    return pb.authStore.onChange((_token, record) => {
      setUser(record);
    }, true);
  }, []);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: pb.authStore.isValid }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}

export function logout(): void {
  pb.authStore.clear();
}
